import { createContext } from "react";

export const errorAlertContextV2 = createContext<
  | ((
      error: unknown,
      title?: string,
      description?: string,
      buttonText?: string,
      showAdditionalHelp?: boolean,
    ) => void)
  | undefined
>(undefined);
